import api from '@pray/shared/utils/api';

export const getContentWithComments = async ({ artistId, cursor } = {}) => {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/content-with-comments`;
  const params = {};
  if (cursor) params.cursor = cursor;

  const response = await api.executeGetRequest(url, params);
  return response.data.data;
};
